<template>
  <div class="container ">
  <scrollactive class="b-block-nav" :scrollOffset="-2" :offset="10" :activeClass="'b-tab-nav__link--active'" v-on:itemchanged="onItemChanged">
      <ul class="b-tab-nav">
        <li class="nav-item b-tab-nav__item" v-if="tabs_check.description" >
          <a class="b-tab-nav__link scrollactive-item"  href="#description"  title="Описание" data-index="1">
            Описание
          </a>
        </li>
        <li class="nav-item b-tab-nav__item" v-if="tabs_check.apartments">
          <a class=" b-tab-nav__link scrollactive-item" href="#apartments"  title="Квартиры" data-index="2">
            Квартиры
          </a>
        </li>
        <li class="nav-item b-tab-nav__item" v-if="tabs_check.reports">
          <a class=" b-tab-nav__link scrollactive-item" href="#reports"  title="Ход строительства" data-index="3">
            Ход строительства
          </a>
        </li>
        <li class="nav-item b-tab-nav__item" v-if="tabs_check.reviews">
          <a class=" b-tab-nav__link scrollactive-item" href="#reviews"  title="Обзоры" data-index="4">
            Обзоры
          </a>
        </li>
        <li class="nav-item b-tab-nav__item">
          <a class=" b-tab-nav__link scrollactive-item" href="#comments"  title="Отзывы" data-index="5">
            Отзывы
          </a>
        </li>
      </ul>

  </scrollactive>
  </div>
</template>
<script>
import VueScrollactive from 'vue-scrollactive';
 export default {
   components:{
     VueScrollactive
   },
   props: {
     tabs_check:Object,
   },
   methods:{
     onItemChanged: function (event, currentItem, lastActiveItem) {

     var activeElem = document.getElementsByClassName('b-tab-nav__link--active')[0];
    if(activeElem) {
      if(currentItem) {
        var current = currentItem.getAttribute("data-index");
      }
      if( lastActiveItem) {
        var prev = lastActiveItem.getAttribute("data-index");
      }
      console.log(prev)
      if(current > prev) {
        activeElem.scrollIntoView({behavior: "smooth", block: "start", inline: "start"});
      } else {
        activeElem.scrollIntoView({behavior: "smooth", block: "start", inline: "end"});
      }

    }



     }
   },
 }
</script>